<template>
  <div id="topbar">
    <slot name="topbar"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "Topbar",
  props: {},
  components: {},
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
#topbar {
  height: 40px;
  background: #EAEAEA;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
  color: black;

  .dark-mode & {
    background:#272727;
    color: white;
  }
}
</style>
